<template>
  <v-container>
    <v-footer padless>
      <v-card flat class="text-center mx-auto justify-content-center">
        <v-card-text class="mx-auto">
          <div class="share-btn-container">
            <a class="pa-3 facebook-btn" v-on:click="init()">
              <i class="fab fa-facebook"></i>
            </a>
            <a href="#" class="pa-3 twitter-btn" v-on:click="twit()">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="pa-3 linkedin-btn" v-on:click="linkedClick()">
              <i class="fab fa-linkedin"></i>
            </a>
            <a href="#" class="pa-3 pinterest-btn" v-on:click="pinClick()">
              <i class="fab fa-pinterest"></i>
            </a>
          </div>
          <!-- <v-btn v-for="icon in icons" :key="icon" class="mx-4" icon>
            <v-icon size="24px">
              {{ icon }}
            </v-icon>
          </v-btn> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text>
          {{ new Date().getFullYear() }} — <strong>Къща за гости Никол</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-container>
</template>

<script>
const postUrl = encodeURI(document.URL);
const postTitle = encodeURI("Здравейте, моля погледнете това:");
const postImg = encodeURI(
  "https://scontent.fsof11-1.fna.fbcdn.net/v/t1.18169-9/13775909_580087522164694_4959286673994418994_n.jpg?_nc_cat=101&ccb=1-3&_nc_sid=09cbfe&_nc_ohc=-mK24AmQB78AX8tIiSJ&_nc_ht=scontent.fsof11-1.fna&oh=78ca57c104a2ea6e91ff6963408b48ff&oe=60ED0C43"
);

export default {
  name: "Footer",
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
  methods: {
    init() {
      var facebookBtn = document.querySelector(".facebook-btn");
      facebookBtn.setAttribute(
        "href",
        "https://www.facebook.com/sharer.php?href=" + postUrl
      );
    },
    twit() {
      var twitterBtn = document.querySelector(".twitter-btn");
      twitterBtn.setAttribute(
        "href",
        `https://twitter.com/share?url=[post-url]&text=${postUrl}&via=[via]&hashtags=${postTitle}`
      );
    },
    linkedClick() {
      const linkedin = document.querySelector(".linkedin-btn");
      linkedin.setAttribute(
        "href",
        `https://www.linkedin.com/shareArticle?url=${postUrl}&title=${postTitle}`
      );
    },
    pinClick() {
      const instagram = document.querySelector(".pinterest-btn");
      instagram.setAttribute(
        "href",
        `https://pinterest.com/pin/create/bookmarklet/?media=${postImg}&url=${postUrl}&description=${postTitle}`
      );
    },
  },
};
</script>
